/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * MCS booking request
 * @export
 * @interface McsBookingRequest
 */
export interface McsBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    jwtToken: string;
    /**
     * 
     * @type {Date}
     * @memberof McsBookingRequest
     */
    bookedForDate: Date;
    /**
     * 
     * @type {number}
     * @memberof McsBookingRequest
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof McsBookingRequest
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof McsBookingRequest
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    selectedOfferToken: string;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    paymentAuthorizationId: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof McsBookingRequest
     */
    selectedExtraIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    webviewVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    appVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McsBookingRequest
     */
    platform?: string | null;
}

/**
 * Check if a given object implements the McsBookingRequest interface.
 */
export function instanceOfMcsBookingRequest(value: object): value is McsBookingRequest {
    if (!('jwtToken' in value) || value['jwtToken'] === undefined) return false;
    if (!('bookedForDate' in value) || value['bookedForDate'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('selectedOfferToken' in value) || value['selectedOfferToken'] === undefined) return false;
    if (!('paymentAuthorizationId' in value) || value['paymentAuthorizationId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function McsBookingRequestFromJSON(json: any): McsBookingRequest {
    return McsBookingRequestFromJSONTyped(json, false);
}

export function McsBookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): McsBookingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'jwtToken': json['jwtToken'],
        'bookedForDate': (new Date(json['bookedForDate'])),
        'locationId': json['locationId'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'address': json['address'],
        'selectedOfferToken': json['selectedOfferToken'],
        'paymentAuthorizationId': json['paymentAuthorizationId'],
        'selectedExtraIds': json['selectedExtraIds'] == null ? undefined : json['selectedExtraIds'],
        'language': json['language'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'appVersion': json['appVersion'] == null ? undefined : json['appVersion'],
        'platform': json['platform'] == null ? undefined : json['platform'],
    };
}

export function McsBookingRequestToJSON(json: any): McsBookingRequest {
    return McsBookingRequestToJSONTyped(json, false);
}

export function McsBookingRequestToJSONTyped(value?: McsBookingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jwtToken': value['jwtToken'],
        'bookedForDate': value['bookedForDate'].toISOString(),
        'locationId': value['locationId'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'address': value['address'],
        'selectedOfferToken': value['selectedOfferToken'],
        'paymentAuthorizationId': value['paymentAuthorizationId'],
        'selectedExtraIds': value['selectedExtraIds'],
        'language': value['language'],
        'webviewVersion': value['webviewVersion'],
        'appVersion': value['appVersion'],
        'platform': value['platform'],
    };
}

